import React from "react";
import FormControl from "@mui/material/FormControl";
import RadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from "@mui/material/RadioGroup";

export default function RadioButtonGroup({
  children,
  className,
  "aria-describedby": ariaDescribedby,
  ...props
}: MuiRadioGroupProps) {
  return (
    <FormControl className={className}>
      <RadioGroup
        {...props}
        className={className}
        aria-describedby={ariaDescribedby}
      >
        {children}
      </RadioGroup>
    </FormControl>
  );
}
